import { PassengerDisabilitiesState } from './types';

interface PassengerValues {
	disabilities?: PassengerDisabilitiesState;
}

const isSelectedItems = (values: PassengerDisabilitiesState['values']) =>
	Object.values(values ?? {}).some(isChecked => isChecked);

export const validateDisabilities = (passengerValues?: PassengerValues) => {
	const disabilities = passengerValues?.disabilities;

	if (!disabilities) {
		return null;
	}

	const hasSelectedItems = isSelectedItems(disabilities.values);

	if (disabilities.enabled && !hasSelectedItems) {
		return 'Select at least one service from the list below';
	}

	return null;
};
